const apiBase = '/api/v1/network-groups';

export enum Actions {
  GET_NETWORK_GROUP_SUCCESS = '@network_group/GET_NETWORK_GROUP_SUCCESS',
  GET_NETWORK_GROUP_ERROR = '@network_group/GET_NETWORK_GROUP_ERROR',
  GET_NETWORK_GROUP_LOADING = '@network_group/GET_NETWORK_GROUP_LOADING'
}

export const getNetworkGroup = (id: string | number) => ({
  type: 'API_GET',
  path: `${apiBase}/${id}`,
  success: Actions.GET_NETWORK_GROUP_SUCCESS,
  error: Actions.GET_NETWORK_GROUP_ERROR,
  loading: Actions.GET_NETWORK_GROUP_LOADING
});
